// extracted by mini-css-extract-plugin
export default {"heading":"Heading_heading__VSH0w"};